import ProfileWidget from "components/organisms/ProfileWidget";
import { useGetLoyaltyUser } from "queries/useGetLoyaltyUser";
import { useGetProgressLoyalty } from "queries/useGetProgressLoyalty";
import { useGetUserMascots } from "queries/useGetUserMascots";
import { getCurrentRank, getProgressOnRank } from "utils/loyalty";
import { userApi } from "redux/user/api";
import { useMemo } from "react";
import useTranslate from "hooks/useTranslate";
import { useNavigate } from "react-router-dom";
import url from "../../url";
import { useLoyaltyStore } from "../../stores/loyalty";
import { LoyaltyTabs } from "../../constants/loyalty";
import { useGetExpSettingCurrency } from "../../queries/useGetExpSettingCurrency";

const ProfileWidgetContainer = () => {
  const t = useTranslate();
  const navigate = useNavigate();
  const { data: loyaltyData } = useGetLoyaltyUser();
  const { data: progressData } = useGetProgressLoyalty();
  const loyalty = loyaltyData?.data?.data;
  const experience = progressData?.data?.data?.experience || 0;
  const { currentRank } = getCurrentRank(loyalty, experience);
  const rankName = currentRank?.name || "";
  const { data } = userApi.useGetProfileQuery("");
  const nickname = data?.user?.name || undefined;
  const idUser = data?.user?.id;
  const { exp } = useGetExpSettingCurrency();
  const { progressRankPercent, maxExperienceRank } = useMemo(
    () => getProgressOnRank(loyalty, experience),
    [loyalty, experience],
  );
  const setLocationLoyalty = useLoyaltyStore(
    (state) => state.setLocationLoyalty,
  );

  const { data: mascotsUser } = useGetUserMascots();

  const activeMascot =
    mascotsUser?.data?.data?.find((mascot) => mascot.status === "active") ||
    null;

  const onClickAvatar = () => {
    setLocationLoyalty(LoyaltyTabs.AVATAR);
    navigate(url.routes.profile.loyaltyProgram());
  };

  return (
    <ProfileWidget
      id={idUser}
      nickname={nickname}
      experience={experience}
      experienceRankMax={maxExperienceRank}
      percent={progressRankPercent}
      nameRank={t(rankName)}
      avatar={activeMascot?.link}
      handleClickAvatar={onClickAvatar}
      experienceSettings={exp}
    />
  );
};

export default ProfileWidgetContainer;
